import { Component, ViewEncapsulation } from '@angular/core';
import { Configuration } from '../../../configuration';

@Component({
    selector: 'blank',
    template: require('./blank.component.html'),
    styles: [require('./environment.banner.css')],
    encapsulation: ViewEncapsulation.None
})
export class BlankComponent {
    constructor(public configuration: Configuration) { }

    public notificationOptions = {
        position: ['top', 'right'],
        timeOut: 5000
    }

    ngAfterViewInit() {
        jQuery('body').addClass('gray-bg');
    }

    ngOnDestroy() {
        jQuery('body').removeClass('gray-bg');
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/layouts/blank.component.ts